import {
    Box,
    Typography,
    IconButton,
    Stack,
    Divider,
    List,
    Button,
    ListItem,
    ListItemIcon,
    ListItemText,
    Switch,
    Container,
  } from "@mui/material";
  import { Link, useNavigate } from "react-router-dom";
  import Navbar from "../Navbar";
  import { AiOutlineArrowLeft } from "react-icons/ai";
  import React from "react";
  import {
    MdDarkMode,
    MdInfo,
    MdEmail,
    MdCode,
    MdHelpOutline,
    MdPerson,
  } from "react-icons/md";
  
  const SettingsView = () => {
    const navigate = useNavigate();
    const [darkMode, setDarkMode] = React.useState(false);
  
    const handleBackClick = () => {
      navigate(-1); // Goes back to previous page
    };
  
    return (
      <Box sx={{ backgroundColor: "#F5F5F5", minHeight: "100vh" }}>
        <Navbar />
        <Container maxWidth="md" sx={{ py: 4 }}>
          {/* Navigation Header */}
          <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 4 }}>
            <IconButton
              onClick={handleBackClick}
              aria-label="back"
              sx={{
                color: "primary.main",
                "&:hover": {
                  backgroundColor: "action.hover",
                },
              }}
            >
              <AiOutlineArrowLeft size={24} />
            </IconButton>
            <Typography 
              variant="h4" 
              component="h1"
              sx={{
                fontWeight: 700,
                background: "linear-gradient(135deg, #7C3AED 0%, #A855F7 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              Settings
            </Typography>
          </Stack>
    
          {/* Settings Content */}
          <Box
            sx={{
              borderRadius: "16px",
              p: 4,
              backgroundColor: "white",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            }}
          >
         
        
            {/* <ListItem>
              <ListItemIcon>
                <MdDarkMode size={24} />
              </ListItemIcon>
              <ListItemText primary="Dark Mode" />
              <Switch
                checked={darkMode}
                onChange={() => setDarkMode(!darkMode)}
                color="primary"
              />
            </ListItem> */}

        <List>
            <Divider />
  
            {/* About Section */}
            <ListItem button component={Link} to="/settings/about">
              <ListItemIcon>
                <MdInfo size={24} />
              </ListItemIcon>
              <ListItemText primary="About" secondary="Learn about this application" />
            </ListItem>
            <Divider />
  
            {/* Contact Section */}
            <ListItem button component={Link} to="/settings/contact">
              <ListItemIcon>
                <MdEmail size={24} />
              </ListItemIcon>
              <ListItemText primary="Contact Us" secondary="Get in touch with our team" />
            </ListItem>
            <Divider />
  
            {/* Developer Section */}
            <ListItem button component={Link} to="/settings/developer">
              <ListItemIcon>
                <MdCode size={24} />
              </ListItemIcon>
              <ListItemText 
                primary="Developer Info" 
                secondary="About the creator of this app" 
              />
            </ListItem>
            <Divider />
  
            {/* Help & Support */}
            <ListItem button component={Link} to="/settings/help">
              <ListItemIcon>
                <MdHelpOutline size={24} />
              </ListItemIcon>
              <ListItemText primary="Help & Support" secondary="Get assistance" />
            </ListItem>
            <Divider />
  
            {/* User Profile */}
            <ListItem button component={Link} to="/settings/profile">
              <ListItemIcon>
                <MdPerson size={24} />
              </ListItemIcon>
              <ListItemText primary="Your Profile" secondary="View and edit your profile" />
            </ListItem>
          </List>
  
          {/* Back to Home Button */}
          <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              component={Link}
              to="/"
              size="large"
              sx={{ 
                px: 4,
                borderRadius: "12px",
                textTransform: "none",
                fontWeight: 600,
                background: "linear-gradient(135deg, #7C3AED 0%, #A855F7 100%)",
                boxShadow: "0 4px 12px rgba(124,58,237,0.3)",
                "&:hover": {
                  background: "linear-gradient(135deg, #6D28D9 0%, #9333EA 100%)",
                  boxShadow: "0 6px 16px rgba(124,58,237,0.4)",
                },
              }}
            >
              Back to Home
            </Button>
          </Box>
        </Box>
        </Container>
      </Box>
    );
  };
  
  export default SettingsView;